export default "__VITE_ASSET__B5d33pTu__"